// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2LtsJ","col":"Table_col__1CY4X","fulfillmentStatus":"Table_fulfillmentStatus__f6WNy","emailCol":"Table_emailCol__3N9_t"};